<template>
  <v-card outlined class="rounded-lg pa-6 card-evaluacion mx-auto my-4 d-flex flex-column flex-grow-1" max-width="750">
    <v-card-text class="pa-0 flex-grow-1">
      <!-- Título de la evaluación -->
      <h3 class="primary--text font-weight-bolder museo-text bolder-text text-h6 mb-4">
        {{ titulo }}
      </h3>

      <!-- Tipo de prueba -->
      <div class="tipo-prueba-label mb-4">
        Tipo de prueba: <span class="font-weight-medium text-capitalize">{{ tipoDePrueba }}</span>
      </div>

      <!-- Fechas de Inicio y Fin -->
      <v-row class="mb-3" dense>
        <v-col cols="12" sm="6" class="d-flex align-center py-1">
          <v-icon color="#5C6B73" class="mr-2" size="20">mdi-calendar-blank-outline</v-icon>
          <span class="info-text">
            Inicia: <span class="font-weight-medium">{{ inicia }}</span>
          </span>
        </v-col>
        <v-col cols="12" sm="6" class="d-flex align-center py-1">
          <v-icon color="#5C6B73" class="mr-2" size="20">mdi-calendar-blank-outline</v-icon>
          <span class="info-text">
            Finaliza: <span class="font-weight-medium">{{ finaliza }}</span>
          </span>
        </v-col>
      </v-row>

      <!-- Duración -->
      <v-row class="mb-5" dense>
        <v-col cols="12" class="d-flex align-center py-1">
          <v-icon color="#5C6B73" class="mr-2" size="20">mdi-clock-outline</v-icon>
          <span class="info-text">
            Duración: <span class="font-weight-medium">{{ duracion }}</span>
          </span>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- Pie / Botón de Acción -->
    <v-card-actions v-if="btnConfig" class="pa-0 d-flex justify-center">
      <v-btn :color="btnConfig.color" :outlined="btnConfig.outlined" :dark="btnConfig.dark"
        :style="btnConfig.customStyle" class="text-none rounded-xl px-12 py-5 font-weight-bold card-btn" min-width="260"
        elevation="0" @click="$emit('click-action', estado)">
        {{ estado }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "CardEvaluacion",
  props: {
    titulo: {
      type: String,
      required: true,
      default: ""
    },
    tipoDePrueba: {
      type: String,
      required: true,
      default: ""
    },
    inicia: {
      type: String,
      required: true,
      default: ""
    },
    finaliza: {
      type: String,
      required: true,
      default: ""
    },
    duracion: {
      type: String,
      required: true,
      default: ""
    },
    estado: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    btnConfig() {
      const normalizedState = this.estado ? this.estado.trim() : "";

      if (normalizedState === "Iniciar evaluación") {
        return {
          color: "primary",
          outlined: false,
          dark: true,
          customStyle: {}
        };
      } else if (normalizedState === "Ver detalles") {
        return {
          color: "primary",
          outlined: true,
          dark: false,
          customStyle: {}
        };
      }

      return null;
    }
  }
};
</script>

<style scoped>
.card-evaluacion {
  border: 1px solid #E2E8F0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
  /*transition: transform 0.2s ease, box-shadow 0.2s ease;*/
}

.card-evaluacion:hover {
  /*transform: translateY(-2px);*/
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04) !important;
}

.museo-text {
  font-family: 'MuseoSans', sans-serif !important;
}

.bolder-text {
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.1px 0 0 currentColor, -0.1px 0 0 currentColor;
}

.tipo-prueba-label {
  font-size: 14px;
  color: #5C6B73;
}

.info-text {
  font-size: 14px;
  color: #5C6B73;
}

.card-btn {
  font-size: 15px !important;
  letter-spacing: 0.5px;
}
</style>
